import React, { ReactElement } from 'react';
import { Theme } from '@kb-front/ui-kit';
import { Footer, FooterKB, Header, HeaderKb } from 'birbank-additional';

import { useGeneralInfoContext } from 'shared/context/WithGeneralInfo/GeneralInfoContext';

import { ESalesChannel } from '../enum';

const Layout: React.FC = ({ children }): ReactElement => {
  const { channelType } = useGeneralInfoContext();

  const isKBChannel = channelType !== ESalesChannel.TERMINAL && channelType !== ESalesChannel.BIRBANK_AZ;

  const getHeader = () => {
    if (channelType === ESalesChannel.TERMINAL) return '';
    if (isKBChannel) return <HeaderKb />;
    return <Header />;
  };

  const getFooter = () => {
    if (channelType === ESalesChannel.TERMINAL) return '';
    if (isKBChannel) return <FooterKB />;
    return <Footer />;
  };

  const header = getHeader();
  const footer = getFooter();

  return (
    <Theme.Provider>
      {({ theme }) => (
        <Theme theme={theme}>
          <div className={isKBChannel ? 'kb-design' : ''}>
            {header}
            <main>{children}</main>
            {footer}
          </div>
        </Theme>
      )}
    </Theme.Provider>
  );
};

export default Layout;
